import {INDEX_ATTRIBUTE} from '../../../AgentsSidebar/AgentsSidebarItem/AgentsSidebarItem'

export const findItemWithin = (
  itemIndex: number,
  parent: HTMLElement | null | undefined,
): HTMLElement | null | undefined => parent?.querySelector(`[${INDEX_ATTRIBUTE}="${itemIndex}"]`)
